// Single source of truth for a coin's logo URL across the app.
//
// Priority:
//   1. Backend-provided `iconUrl` when the API populates it.
//   2. Local /CompanyLogo/<TICKER>.svg fallback for tickers we ship locally.
//   3. null — callers must render their own fallback glyph.
//
// All ranking/search/favorites views must use this helper so the same coin
// shows the same logo no matter where it appears.
export const getCoinLogoPath = (coin) => {
  if (!coin) return null;
  if (typeof coin === 'string') {
    return `/CompanyLogo/${coin}.svg`;
  }
  if (coin.iconUrl) return coin.iconUrl;
  if (coin.ticker) return `/CompanyLogo/${coin.ticker}.svg`;
  return null;
};
